/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageContent } from '../../models/image-content';
import { ImageContentApiRespModel } from '../../models/image-content-api-resp-model';

export interface ApiMasterImageContentEditPost$Params {
      body?: ImageContent
}

export function apiMasterImageContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageContentApiRespModel>;
    })
  );
}

apiMasterImageContentEditPost.PATH = '/api/Master/ImageContent/Edit';
